import { DeactivatedEmployees } from './DeactivatedEmployees';
export { DeactivatedEmployees };
export default DeactivatedEmployees;
